import { useEffect } from 'react';
import { View, ActivityIndicator } from 'react-native';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { useTheme } from '@/contexts/ThemeContext';

export default function DuelRedirect() {
  const { theme } = useTheme();
  const router = useRouter();
  const { id } = useLocalSearchParams();
  const duelId = typeof id === 'string' ? id : '';

  useEffect(() => {
    if (duelId) {
      router.replace(`/duels/${duelId}`);
    } else {
      router.replace('/duels/unknown');
    }
  }, [duelId, router]);

  return (
    <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: theme.colors.background }}>
      <ActivityIndicator color={theme.colors.textSecondary} />
    </View>
  );
}
